import {SelectField} from './select-field';
import {GridWidgetFilter} from './grid-widget-filter';
import {MultiSelectFilter} from './multi-select-filter';
import {OrderedMap} from '../ordered-map';
export class MultiSelectField extends SelectField {

  //This is the number of check boxes that can show up on a multiselect filter in the UI before it changes to the dropdown.
  //Brian thinks the right number is 5, but the designers have said otherwise.
  //I've decided to make this a configurable field so it will be easy to update if we get feedback asking for the threshold
  //to be larger.
  popupThreshold = 1;

  /**
   * This is a static method so it could be used by InverseMultiSelectField too.
   * @param dataValue
   * @param selectOptions
   * @returns {string|undefined|string}
   */
  static multiSelectResolveAsString(dataValue: any, selectOptions: OrderedMap<any>): string {

    let matchValue: string | undefined;
    for (let uiValue of selectOptions.keys()) {
      let match = false;
      if (typeof selectOptions.get(uiValue) === 'function') {
        match = selectOptions.get(uiValue)(dataValue);
      } else {
        match = selectOptions.get(uiValue) === dataValue;
      }

      if (match) {
        if (matchValue == null) {
          matchValue = uiValue;
        } else {
          console.error('selectOptions has multiple keys for the same value: ' + dataValue);
        }
      }
    }

    return matchValue || '';
  }

  getFilterInstance(): GridWidgetFilter {
    return new MultiSelectFilter(this);
  }

  resolveAsString(dataRow: any): string {
    return MultiSelectField.multiSelectResolveAsString(this.resolve(dataRow), this.selectOptions);
  }
}
